/**
 * ONTHEPITCH — i18next configuration
 * ---------------------------------------------------------
 * Adding a new language:
 *   1. Drop a JSON file in /src/locales/{code}.json
 *   2. Add the entry to `SUPPORTED_LANGUAGES` below.
 *
 * Persistence:
 *   - Anonymous users → localStorage["lang"]
 *   - Authenticated users → backend `users.language`, PUT /api/auth/profile.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import bg from "./locales/bg.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGUAGES = [
  { code: "bg", label: "Български", short: "БГ", flag: "🇧🇬" },
  { code: "en", label: "English",   short: "EN", flag: "🇬🇧" },
];
export const SUPPORTED_LANG_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);
export const DEFAULT_LANG = "en";

const stored = (typeof window !== "undefined" && localStorage.getItem("lang")) || DEFAULT_LANG;
const initial = SUPPORTED_LANG_CODES.includes(stored) ? stored : DEFAULT_LANG;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      bg: { translation: bg },
      en: { translation: en },
    },
    lng: initial,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    returnNull: false,
    returnEmptyString: false,
    react: { useSuspense: false },
  });

export default i18n;
